export enum WarehouseItemWorkRequestKind {
  Photo = "photo",
}
